var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.111 10.4891L13.5999 8.00024M13.5999 8.00024L11.111 5.51135M13.5999 8.00024L4.88879 8.00024M8.62212 10.4891V11.1113C8.62212 12.1423 7.78639 12.978 6.75546 12.978H4.26657C3.23564 12.978 2.3999 12.1423 2.3999 11.1113V4.88913C2.3999 3.8582 3.23564 3.02246 4.26657 3.02246H6.75546C7.78639 3.02246 8.62212 3.8582 8.62212 4.88913V5.51135",
    stroke: "#EF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.52e91238dde1edd85294adf5f5995ecb.svg";
export { ForwardRef as ReactComponent };